import { Action } from 'redux';
import { LOCATION_CHANGE } from 'react-router-redux';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { AppState } from '../reducers';

export interface Navigation {
  currentSite?: string;
}

type NavigationState = Navigation & ImmutableObject<Navigation>;

export interface RouterProps<Params> {
  location: {
    hash: string;
    key: string;
    pathname: string;
    search: string;
    state: undefined;
  };
  match: {
    isExact: boolean;
    params: Params;
    path: string;
    url: string;
  };
}
const initialState = Immutable.from<Navigation>({
  currentSite: void 0,
});
export default function reduce(
  state: NavigationState = initialState,
  action: Action
) {
  if (action.type === LOCATION_CHANGE) {
    const payload = (action as any).payload;

    return state.merge({ currentSite: payload.pathname });
  }

  return state;
}

export function getCurrentSite(state: AppState) {
  const {
    navigation: { currentSite },
  } = state;

  return currentSite;
}



// WEBPACK FOOTER //
// ./src/store/Navigation/navigation.reducer.ts